import { anyAsset, AssetTypesLocalized, AssetUIModel, CanPipe, FieldType, FilterFormDataModel, WidthClass } from '@thehubz/client/core';
import { Asset } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { AssetMimeType } from '@thehubz/shared/model';
import { AssetMetadata } from '../../components/asset-detail-view/asset-info/models/asset-info.interface';

const AnyAsset = anyAsset;

export const Alignment = [
  { _id: 'horizontal', name: 'Horizontal' },
  { _id: 'square', name: 'Quadrat' },
  { _id: 'vertical', name: 'Vertikal' },
];
export const AgeGroup = [
  { _id: 'adult', name: 'Erwachsener' },
  { _id: 'child', name: 'Kind' },
  { _id: 'senior', name: 'Senior' },
  { _id: 'youngadult', name: 'Junger Erwachsener' },
];
export const GroupOfPeople = [
  { _id: 'couple', name: 'Paar' },
  { _id: 'family', name: 'Familie' },
  { _id: 'group', name: 'Gruppe' },
  { _id: 'none', name: 'Keine' },
  { _id: 'oneperson', name: 'Eine Person' },
];
export const Products = [
  { _id: 'aal', name: 'AAL' },
  { _id: 'about_arval', name: 'Über Arval' },
  { _id: 'amo', name: 'AMO' },
  { _id: 'aos', name: 'AOS' },
  { _id: 'athena', name: 'Athena' },
  { _id: 'cart', name: 'CART' },
  { _id: 'corporate', name: 'Corporate' },
  { _id: 'csr', name: 'CSR' },
  { _id: 'ev', name: 'EV' },
  { _id: 'fuel_card_management', name: 'Tankkartenmanagement EV' },
  { _id: 'general', name: 'Allgemein' },
  { _id: 'hr', name: 'HR' },
  { _id: 'ifrs_16', name: 'IFRS 16' },
  { _id: 'logistics', name: 'Logistik' },
  { _id: 'maintenance_service', name: 'Wartungsservice' },
  { _id: 'motortrade', name: 'Motortrade' },
  { _id: 'mtr', name: 'MTR' },
  { _id: 'my_arval', name: 'My Arval' },
  { _id: 'nps', name: 'NPS' },
  { _id: 'private_lease', name: 'Private Lease' },
  { _id: 'smart', name: 'SMaRT' },
  { _id: 'sme', name: 'SME' },
  { _id: 'tire_service', name: 'Reifenservice' },
  { _id: 'vehicle_fleet_leasing', name: 'Fuhrparkleasing' },
];
export const Channel = [
  { _id: 'digital', name: 'Digital' },
  { _id: 'general', name: 'Generell' },
  { _id: 'print', name: 'Print' },
];
export const Type = [
  { _id: 'factsheet', name: 'Factsheet' },
  { _id: 'header', name: 'Header' },
  { _id: 'homepage_block', name: 'Startseitenblock' },
  { _id: 'presentation', name: 'Präsentation' },
  { _id: 'showpad', name: 'Showpad' },
  { _id: 'slider', name: 'Slider' },
];

export const arvalAssetMetadataConfig = (assetInfo: AssetUIModel, canPipe: CanPipe): AssetMetadata => {
  const status: { id: Asset.StatusEnum; name: string }[] = [{ id: Asset.StatusEnum.Pending, name: $localize`Pending` }];
  /**
   * Below condition is used to check whether a user have right to set asset status 'Approved'.
   */
  if (canPipe.transform(AnyAsset, 'update.allstatus')) {
    status.push({ id: Asset.StatusEnum.Approved, name: $localize`Approved` });
  }
  /**
   * Below condition is used to check whether a user have right to set asset status 'Archived'.
   */
  if (canPipe.transform(AnyAsset, 'archived')) {
    status.push({
      id: Asset.StatusEnum.Archived,
      name: $localize`Archived`,
    });
  }
  return {
    customerName: CustomClients.Arval,
    metadata: [
      {
        fieldLabel: 'Name',
        editable: true,
        formControlName: 'name',
      },
      {
        fieldLabel: 'Status',
        editable: true,
        formControlName: 'status',
        options: status,
      },
      {
        fieldLabel: 'Erstellt am',
        editable: false,
        formControlName: 'createdAt',
      },
      {
        fieldLabel: 'Erstellt von',
        editable: false,
        formControlName: 'createdBy',
      },
      {
        fieldLabel: 'Geändert am',
        editable: false,
        formControlName: 'updatedAt',
      },
      {
        fieldLabel: 'Geändert von',
        editable: false,
        formControlName: 'updatedBy',
      },
      {
        fieldLabel: $localize`Description`,
        editable: true,
        formControlName: 'description',
      },
    ],
  };
};

export const arvalFilterFormData: FilterFormDataModel = {
  title: 'Asset',
  description: '',
  customClient: CustomClients.Arval,
  formFields: [
    {
      formTypeId: '1',
      formFieldName: 'assetType',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Asset Typ',
      placeholder: '-- Auswählen --',
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      visible: true,
      options: AssetTypesLocalized,
    },
    {
      formTypeId: '2',
      formFieldName: 'alignment',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Ausrichtung',
      placeholder: '-- Auswählen --',
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      formGroup: true,
      visible: true,
      options: Alignment,
      multiple: true,
    },
    {
      formTypeId: '3',
      formFieldName: 'fileType',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Dateityp',
      placeholder: '-- Auswählen --',
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      visible: true,
      options: AssetMimeType.flat(2),
    },
    {
      formTypeId: '4',
      formFieldName: 'ageGroup',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Altersgruppe',
      placeholder: '-- Auswählen --',
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      formGroup: true,
      visible: true,
      options: AgeGroup,
      multiple: true,
    },
    {
      formTypeId: '5',
      formFieldName: 'expiryDate',
      fieldType: FieldType.Date,
      fieldLabel: 'Gültig bis (Ablaufdatum)',
      placeholder: 'Gültig bis (Ablaufdatum)',
      inputType: '',
      mandatory: true,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
    {
      formTypeId: '6',
      formFieldName: 'groupOfPeople',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Personengruppe',
      placeholder: '-- Auswählen --',
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      formGroup: true,
      visible: true,
      options: GroupOfPeople,
      multiple: true,
    },
    {
      formTypeId: '7',
      formFieldName: 'createdAt',
      fieldType: FieldType.Date,
      fieldLabel: 'Erstellt am',
      placeholder: 'Erstellt am',
      inputType: '',
      mandatory: true,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
    {
      formTypeId: '8',
      formFieldName: 'status',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Status',
      placeholder: '-- Auswählen --',
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      visible: true,
      multiple: true,
      options: [
        {
          id: Asset.StatusEnum.Pending,
          name: $localize`Pending`,
        },
        {
          id: Asset.StatusEnum.Approved,
          name: $localize`Approved`,
        },
      ],
    },
    {
      formTypeId: '9',
      formFieldName: 'product',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Produkt',
      placeholder: '-- Auswählen --',
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      formGroup: true,
      visible: true,
      options: Products,
    },
    {
      formTypeId: '10',
      formFieldName: 'channel',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Kanal',
      placeholder: '-- Auswählen --',
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      formGroup: false,
      disable: false,
      visible: true,
      options: Channel,
    },
    {
      formTypeId: '11',
      formFieldName: 'type',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Typ',
      placeholder: '-- Auswählen --',
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      formGroup: false,
      disable: false,
      visible: true,
      options: Type,
    },
  ],
};
